import { render, staticRenderFns } from "./ContractInfo.vue?vue&type=template&id=2c16317e&scoped=true&"
import script from "./ContractInfo.vue?vue&type=script&lang=ts&"
export * from "./ContractInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ContractInfo.vue?vue&type=style&index=0&id=2c16317e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c16317e",
  null
  
)

export default component.exports